import apiClient from '@/utils/apiClient';

const VERIFY_CAPTCHA_API_PATH = '/api/v2/receptionist-dashboard/captcha/verify';

export const verifyCaptcha = async (
	token: string,
): Promise<{ success: boolean; message: string }> => {
	const response = await apiClient.request({
		method: 'POST',
		endPoint: VERIFY_CAPTCHA_API_PATH,
		body: { response: token },
	});

	return response;
};
